import { Collapse } from 'antd'
import React from 'react'
import FacebookSetting from './FacebookSetting'
import SmsSetting from './SmsSetting'

const { Panel } = Collapse

const ShareSetting = ({ smsConfig, facebookConfig, onSmsChange, onFacebookChange }) => {
    return (
        <Collapse style={{ margin: 5 }}>
            <Panel header="Share">
                <SmsSetting smsConfig={smsConfig} onSmsChange={onSmsChange} />
                <FacebookSetting facebookConfig={facebookConfig} onFacebookChange={onFacebookChange} />
            </Panel>
        </Collapse>
    )
}

export default ShareSetting
